/*eslint-disable*/
import React, { createContext, useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import operationsService from '../services/Operation/operationsService'
import pgaService from '../services/Operation/PGA/pgaService'
import pgiService from '../services/Operation/PGI/pgiService'
// import pgaService from '../services/Operation/PGA/pgaService'
import { requestService } from '../services/Operation/Requests/requestsService'
import { useAuthentication } from './authenticationContext'

const OperationsContext = createContext()

export const operationUIContext = () => {
  return useContext(OperationsContext)
}

export const OperationsContextProvider = ({ children }) => {
  const [operation, setOperation] = useState(null)
  const [operationID, setOperationID] = useState(null)
  const [operationLoanID, setOperationLoanID] = useState(null)
  const [operationsList, setOperationsList] = useState(null)
  const [addcomponent, setaddcomponent] = useState({})
  const [operationPGI, setOperationPGI] = useState(null)
  const [operationHistoryPGI, setOperationHistoryPGI] = useState(null)
  const [operationHistoryPGA, setOperationHistoryPGA] = useState(null)
  const [operationModificatedPGI, setOperationModificatedPGI] = useState(null)
  const [operationsRequestsListPGI, setOperationsRequestsListPGI] =
    useState(null)
  const [operationsRequestsListPGA, setOperationsRequestsListPGA] =
    useState(null)
  const [dataRequestPGA, setDataRequestPGA] = useState(null)
  const [operationsRequest, setOperationsRequest] = useState(null)

  return (
    <OperationsContext.Provider
      value={{
        operation,
        setOperation,
        addcomponent,
        setaddcomponent,
        operationID,
        setOperationID,
        operationLoanID,
        setOperationLoanID,
        operationsList,
        setOperationsList,
        operationPGI,
        setOperationPGI,
        operationHistoryPGI,
        setOperationHistoryPGI,
        operationHistoryPGA,
        setOperationHistoryPGA,
        operationModificatedPGI,
        setOperationModificatedPGI,
        operationsRequestsListPGI,
        setOperationsRequestsListPGI,
        operationsRequestsListPGA,
        setOperationsRequestsListPGA,
        operationsRequest,
        setOperationsRequest,
        dataRequestPGA,
        setDataRequestPGA,
      }}
    >
      {children}
    </OperationsContext.Provider>
  )
}

export const useOperationsList = () => {
  const [loadingOperations, setLoadingOperations] = useState(OperationsContext)
  const { userToken } = useAuthentication()
  const { operationsList, setOperationsList } = useContext(OperationsContext)

  useEffect(async () => {
    try {
      setLoadingOperations(true)
      operationsService.get(userToken).then((operationsList) => {
        if (operationsList) {
          setOperationsList(operationsList)
        }
        setLoadingOperations(false)
      })
    } catch (error) {
      console.error('TODO: Handle operations api', { error })
    }
  }, [])

  return { loadingOperations, operationsList }
}

export const useOperation = () => {
  const [loading, setLoading] = useState(false)
  const { userToken } = useAuthentication()

  const { operationId: id, bankOperation: bankOperation } = useParams()
  const {
    operation,
    setOperation,
    operationID,
    setOperationID,
    operationLoanID,
    setOperationLoanID,
  } = useContext(OperationsContext)

  useEffect(() => {
    try {
      if (id && bankOperation) {
        setLoading(true)
        setOperationID(id)
        bankOperation && setOperationLoanID(bankOperation)
        operationsService
          .postOne(id, bankOperation, userToken)
          .then((operation) => {
            setOperation(operation)
            setLoading(false)
            if (operationLoanID === undefined || operationLoanID === null) {
              const { RetrieveLoanFulfillmentArrangementLoanDetailResponse } =
                operation
              setOperationLoanID(
                RetrieveLoanFulfillmentArrangementLoanDetailResponse?.Loan
                  .LoanNumber,
              )
            }
          })
      }
    } catch (error) {
      console.error('TODO: Handle operation api', { error })
    }
  }, [id, bankOperation])

  return { loading, operation, operationID, operationLoanID }
}
export const useOperationPGI = () => {
  const [loading, setLoading] = useState(false)
  const [loadingHistory, setLoadingHistory] = useState(false)
  // const { userToken } = useAuthentication()

  const { operationId: id } = useParams()
  const {
    operationPGI,
    setOperationPGI,
    operationHistoryPGI,
    setOperationHistoryPGI,
    operationModificatedPGI,
    setOperationModificatedPGI,
  } = useContext(OperationsContext)

  useEffect(() => {
    try {
      setLoading(true)

      pgiService.getIDPGICurrent(id).then(({ data }) => {
        const { pgiId } = data
        pgiService.get(pgiId).then((pgi) => {
          setOperationPGI(pgi)
          setLoading(false)
        })
      })

      pgiService.getHistory(id).then((history) => {
        setOperationHistoryPGI(history)
        setLoadingHistory(false)
      })

      pgiService.getModificated(id).then((modificated) => {
        setOperationModificatedPGI(modificated)
        setLoading(false)
      })
    } catch (error) {
      console.error('TODO: Handle operation api', { error })
    }
  }, [id, setOperationPGI])

  return {
    loading,
    operationPGI,
    loadingHistory,
    operationHistoryPGI,
    operationModificatedPGI,
    id,
  }
}

export const useOperationPGA = () => {
  const [loadingHistory, setLoadingHistory] = useState(false)
  const { operationId: id } = useParams()
  const [operationHistoryPGA, setOperationHistoryPGA] = useState([])

  useEffect(() => {
    try {
      setLoadingHistory(true)

      pgaService.getHistory(id).then((history) => {
        setOperationHistoryPGA(history)
        setLoadingHistory(false)
      })
    } catch (error) {
      console.error('TODO: Handle operation api', { error })
    }
  }, [id, setOperationHistoryPGA])

  return {
    loadingHistory,
    operationHistoryPGA,
    id,
  }
}

export const useOperationsRequestsList = () => {
  const [loadingRequestsPGI, setLoadingRequestsPGI] = useState(false)
  const [loadingRequestsPGA, setLoadingRequestsPGA] = useState(false)
  const { operationId: id, bankOperation: bankOperation } = useParams()
  const {
    operationsRequestsListPGI,
    setOperationsRequestsListPGI,
    operationsRequestsListPGA,
    setOperationsRequestsListPGA,
    operationID,
    setOperationID,
    setOperationLoanID,
  } = useContext(OperationsContext)

  useEffect(async () => {
    try {
      setOperationID(id)
      setOperationLoanID(bankOperation)
      setLoadingRequestsPGI(true)
      setLoadingRequestsPGA(true)
      requestService.getRequestsListPGI(id).then((result) => {
        setOperationsRequestsListPGI(result)
        setLoadingRequestsPGI(false)
      })
      requestService.getRequestsListPGA(id).then((result) => {
        setOperationsRequestsListPGA(result)
        setLoadingRequestsPGA(false)
      })
    } catch (error) {
      console.error('TODO: Handle operation api', { error })
    }
  }, [])

  return {
    loadingRequestsPGI,
    loadingRequestsPGA,
    operationsRequestsListPGI,
    operationsRequestsListPGA,
  }
}

export const useOperationsRequestOnePGI = () => {
  const [loadingRequest, setLoadingRequest] = useState(OperationsContext)
  const { requestId: id } = useParams()
  const { operationsRequest, setOperationsRequest } =
    useContext(OperationsContext)

  useEffect(async () => {
    try {
      setLoadingRequest(true)
      requestService.getOneRequestPGI(id).then((request) => {
        setOperationsRequest(request)
        setLoadingRequest(false)
      })
    } catch (error) {
      console.error('TODO: Handle operations api', { error })
    }
  }, [])

  return { loadingRequest, operationsRequest }
}

export const useOperationsRequestOnePGA = () => {
  const [loadingRequestPGA, setLoadingRequestPGA] = useState(OperationsContext)
  const { dataRequestPGA, setDataRequestPGA } = useContext(OperationsContext)
  const { requestId: id } = useParams()

  useEffect(async () => {
    try {
      setLoadingRequestPGA(true)
      requestService.getOneRequestPGA(id).then((request) => {
        const { data } = request
        setDataRequestPGA(data)
        setLoadingRequestPGA(false)
      })
    } catch (error) {
      console.error('TODO: Handle operations api', { error })
    }
  }, [])

  return { loadingRequestPGA, dataRequestPGA }
}

export const usePgaData = (initialData) => {
  const [loadingAcquisitions, setLoadingAcquisitions] = useState(false)
  // const { userToken } = useAuthentication()
  const [pgaData, setPgaData] = useState(initialData)
  const [pgaStatus, setPgaStatus] = useState(null)
  const { operationId } = useParams()
  useEffect(() => {
    try {
      setLoadingAcquisitions(true)
      pgaService.getCurrentPgaID(operationId).then((result) => {
        const pgaId = result?.data?.pgaId
        if (pgaId !== null) {
          pgaService.getPgaPerID(pgaId).then((pgaData) => {
            setPgaData(pgaData)
            setLoadingAcquisitions(false)
          })
        }
        return pgaId
      })
      pgaService.getCurrentDraftPga(operationId).then((pgaStatus) => {
        setPgaStatus(pgaStatus)
        // const draftStatus = pgaStatus.status
        // if(draftStatus !== null){
        // setPgaStatus(pgaStatus)
        // }
      })
    } catch (error) {
      console.error('TODO: Handle operations api', { error })
    }
  }, [])

  return { loadingAcquisitions, pgaData, pgaStatus }
}

export const useComponentsList = () => {
  const { operationId } = useParams()
  const [loadingAcquisitions, setLoadingAcquisitions] = useState(false)
  const [componentsList, setComponentsList] = useState([])
  useEffect(async () => {
    try {
      setLoadingAcquisitions(true)
      pgaService.getComponents(operationId).then((result) => {
        setComponentsList(result?.componentsFromPgi ?? [])
        setLoadingAcquisitions(false)
      })
    } catch (error) {
      console.error('TODO: Handle operations api', { error })
    }
  }, [])

  return { componentsList, loadingAcquisitions }
}
export const useApplicationRegulations = () => {
  const [loadingAcquisitions, setLoadingAcquisitions] = useState(false)
  // const { userToken } = useAuthentication()
  const [applicableRegulations, setApplicableRegulations] = useState([])

  useEffect(async () => {
    try {
      setLoadingAcquisitions(true)
      pgaService.getApplicationRegulations().then((result) => {
        setApplicableRegulations(result?.applicableRegulations ?? [])
        setLoadingAcquisitions(false)
      })
    } catch (error) {
      console.error('TODO: Handle operations api', { error })
    }
  }, [])

  return { applicableRegulations, loadingAcquisitions }
}

export const useMethods = (category) => {
  const [loadingAcquisitions, setLoadingAcquisitions] = useState(false)
  // const { userToken } = useAuthentication()
  const [methods, setMethods] = useState([])

  useEffect(async () => {
    try {
      setLoadingAcquisitions(true)
      pgaService.getMethods().then((result) => {
        const currentMethods =
          result != null
            ? result[uncapitalizeFirstLetter(category.replace(/ /g, ''))]
            : []
        setMethods(currentMethods)
        setLoadingAcquisitions(false)
      })
    } catch (error) {
      console.error('TODO: Handle operations api', { error })
    }
  }, [])
  return { methods, loadingAcquisitions }
}

function uncapitalizeFirstLetter(string) {
  return string.charAt(0).toLowerCase() + string.slice(1)
}

export const useSelectionProcesses = (category) => {
  const [loadingAcquisitions, setLoadingAcquisitions] = useState(false)
  // const { userToken } = useAuthentication()
  const [selectionProcesses, setSelectionProcesses] = useState([])

  useEffect(async () => {
    try {
      setLoadingAcquisitions(true)
      pgaService.getSelectionProcesses().then((result) => {
        const currentSelectionProcesses =
          result != null
            ? result[uncapitalizeFirstLetter(category?.replace(/ /g, ''))]
            : undefined

        if (currentSelectionProcesses !== undefined) {
          setSelectionProcesses(currentSelectionProcesses ?? [])
        } else {
          setSelectionProcesses(result?.selectionProcesses ?? [])
        }
        setLoadingAcquisitions(false)
      })
    } catch (error) {
      console.error('TODO: Handle operations api', { error })
    }
  }, [])

  return { selectionProcesses, loadingAcquisitions }
}
export const useRevisionTypes = () => {
  const [loadingAcquisitions, setLoadingAcquisitions] = useState(false)
  // const { userToken } = useAuthentication()
  const [revisionTypes, setRevisionTypes] = useState([])

  useEffect(async () => {
    try {
      setLoadingAcquisitions(true)
      pgaService.getRevisionTypes().then((result) => {
        setRevisionTypes(result?.revisionTypes ?? [])
        setLoadingAcquisitions(false)
      })
    } catch (error) {
      console.error('TODO: Handle operations api', { error })
    }
  }, [])

  return { revisionTypes, loadingAcquisitions }
}

// funcion de actualizar el estado
export const useUpdateAcquisitionLineStatus = () => {
  const [loadingAcquisitions, setLoadingAcquisitions] = useState(false)
  // const { userToken } = useAuthentication()
  const [updateAcquisitionLineStatus, setupdateAcquisitionLineStatus] =
    useState([])

  useEffect(async () => {
    try {
      setLoadingAcquisitions(true)
      pgaService.getStatus().then((result) => {
        setupdateAcquisitionLineStatus(
          result?.updateAcquisitionLineStatus ?? [],
        )
        setLoadingAcquisitions(false)
      })
    } catch (error) {
      console.error('TODO: Handle operations api', { error })
    }
  }, [])

  return { updateAcquisitionLineStatus, loadingAcquisitions }
}

// funcion de obtener estados para el combo
export const getStatusList = () => {
  const [loadingAcquisitions, setLoadingAcquisitions] = useState(false)
  // const { userToken } = useAuthentication()
  const [statusList, setStatusList] = useState([])

  useEffect(async () => {
    try {
      setLoadingAcquisitions(true)
      pgaService.getStatusList().then((result) => {
        setStatusList(result?.statusList ?? [])
        setLoadingAcquisitions(false)
      })
    } catch (error) {
      console.error('TODO: Handle operations api', { error })
    }
  }, [])

  return { statusList, loadingAcquisitions }
}
